import SagasHelper from '@kakadu-dev/base-frontend-helpers/helpers/Redux/SagasHelper';
import { takeLatest } from 'redux-saga/effects';
import { AUTHORIZATION_ACTIONS } from "./actionTypes";
import { AuthorizationApi } from "./api";
/**
 * Get user role
 *
 * @param {Object} action Action
 * @param {string} action.type Action name
 * @param {Object} action.payload Action payload
 *
 * @return {Generator<*, void, ?>}
 */

function* userRole(action) {
  yield SagasHelper.defaultAction(action, AuthorizationApi.getUserRole);
}
/**
 * Get users roles
 *
 * @param {Object} action Action
 * @param {string} action.type Action name
 * @param {Object} action.payload Action payload
 *
 * @return {Generator<*, void, ?>}
 */


function* usersRoles(action) {
  yield SagasHelper.defaultAction(action, AuthorizationApi.getUsersRoles);
}
/**
 * Set user role
 *
 * @param {Object} action Action
 * @param {string} action.type Action name
 * @param {Object} action.payload Action payload
 *
 * @return {Generator<*, void, ?>}
 */


function* setUserRole(action) {
  yield SagasHelper.defaultAction(action, AuthorizationApi.setUserRole);
}

export default [takeLatest(AUTHORIZATION_ACTIONS.USER_ROLE, userRole), takeLatest(AUTHORIZATION_ACTIONS.USERS_ROLES, usersRoles), takeLatest(AUTHORIZATION_ACTIONS.SET_USER_ROLE, setUserRole)];